exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rangoL1{background-color:#f4cdcd!important;border:1px solid #f5b6b6}.rangoL2{background-color:#facca5!important;border:1px solid #f8b880}.rangoL3{background-color:#fff2cc!important;border:1px solid #f8e09a}.rangoL4{background-color:#d9ead3!important;border:1px solid #baefa8}.rangoL5{background-color:#a2c4c9!important;border:1px solid #8cb7be}.rangoL6{background-color:#c8d9f7!important;border:1px solid #a0bcee}.rangoL0{background-color:#eceeec;border:1px solid #d4d5d3}.auto1{background-color:#d9ead3!important;border:1px solid #baefa8}.auto2{background-color:#fff2cc!important;border:1px solid #f8e09a}.auto3{background-color:#f4cdcd!important;border:1px solid #f5b6b6}.auto0{background-color:#eceeec;border:1px solid #d4d5d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19481ece","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lideres/components/tableLeaders.vue
// module id = 909
// module chunks = 2